import { useMutation } from "react-query";
import fundingLimit from "../services/fundingLimit";

const useFundingLimit = () => {
  return useMutation(["funding-limit"], fundingLimit);
};

export default useFundingLimit;
